export default "__VITE_ASSET__BLRAUpPC__"